import DesignTokens from '@tableau/design-tokens';

import { CommonStyles } from '~src/commonInfra/styles/CommonStyles';
import { applyColor }from '~src/style/ColorService';

import { cssClass } from '../../../style';

const cssPrefix = 'filter-by';
const PANEL_SPACING = 8;

export namespace FilterByTypePanelStyles {
  export const OptionsSeparator = cssClass(cssPrefix, 'options', {
    fontWeight: 'bold',
    fontSize: CommonStyles.Sizes.NormalFontSize,
    color: applyColor(DesignTokens.color.font.default.secondary, CommonStyles.Colors.Grey102),
    lineHeight: '24px',
    paddingLeft: PANEL_SPACING,
    paddingRight: PANEL_SPACING,
  });

  export const PanelItems = cssClass(cssPrefix, 'panel-items', {
    paddingBottom: PANEL_SPACING,
    $nest: {
      '& label': {
        paddingRight: PANEL_SPACING,
        paddingLeft: PANEL_SPACING,
      },
      '& label:hover:not(.disabled)': { backgroundColor: applyColor(DesignTokens.color.component.background.neutral.default.active, CommonStyles.Colors.Grey235)}
    }
  });

  export const Panel = cssClass(cssPrefix, 'panel', {
    minWidth: 160,
    whiteSpace: 'nowrap',
  });

  export const PanelContent = cssClass(cssPrefix, 'panel-content', {
    padding: PANEL_SPACING,
  });

  export const ClearButton = cssClass(cssPrefix, 'clear-button', {
    ...CommonStyles.Layout.TextAlignRight,
  });

  export const Item = cssClass(cssPrefix, 'item', {
    paddingRight: CommonStyles.Sizes.SmallSpace,
  });

  // correct for ActivitySpinner moving item text
  export const SpinnerOffset = cssClass(cssPrefix, 'spinner-offset', {
    position: 'relative',
    bottom: CommonStyles.Sizes.SmallSpace,
  });
}
